import { jsx, jsxs } from "react/jsx-runtime";
import { useThemeProps } from "@mui/material";
import { forwardRef } from "react";
import { useSlotProps } from "../../../base/index.js";
import { loginFormContainerName, useUtilityClasses } from "./classes.js";
import { Actions } from "./components/Actions.js";
import { Alert } from "./components/Alert.js";
import { Form } from "./components/Form.js";
import { Logo } from "./components/Logo.js";
import { Message } from "./components/Message.js";
import { Root } from "./components/Root.js";
import { Title } from "./components/Title.js";
const LoginFormContainer = forwardRef(
  function LoginFormContainer2(inProps, ref) {
    const props = useThemeProps({
      props: inProps,
      name: loginFormContainerName
    });
    const {
      form,
      logo,
      actions,
      alert,
      alertSeverity = "error",
      onAlertClose,
      title,
      message,
      testId = "login-form-container-root",
      sx,
      className = "",
      components,
      componentsProps
    } = props;
    const showAlert = !!alert;
    const ownerState = props;
    const utilityClasses = useUtilityClasses(ownerState);
    const rootSlotProps = useSlotProps({
      className: `${className} ${utilityClasses.root}`,
      ownerState,
      elementType: Root,
      additionalProps: {
        as: components?.Root,
        sx,
        ref,
        "data-tidal": loginFormContainerName,
        "data-testid": testId
      },
      externalSlotProps: componentsProps?.root
    });
    const logoSlotProps = useSlotProps({
      className: utilityClasses.logo,
      ownerState,
      elementType: Logo,
      additionalProps: { as: components?.Logo },
      externalSlotProps: componentsProps?.logo
    });
    const titleSlotProps = useSlotProps({
      className: utilityClasses.title,
      ownerState,
      elementType: Title,
      additionalProps: {
        as: components?.Title,
        variant: "h6"
      },
      externalSlotProps: componentsProps?.title
    });
    const alertSlotProps = useSlotProps({
      className: utilityClasses.alert,
      ownerState,
      elementType: Alert,
      additionalProps: {
        as: components?.Alert,
        severity: alertSeverity,
        onClose: onAlertClose
      },
      externalSlotProps: componentsProps?.alert
    });
    const messageSlotProps = useSlotProps({
      className: utilityClasses.message,
      ownerState,
      elementType: Message,
      additionalProps: {
        as: components?.Message,
        variant: "body1"
      },
      externalSlotProps: componentsProps?.message
    });
    const formSlotProps = useSlotProps({
      className: utilityClasses.form,
      ownerState,
      elementType: Form,
      additionalProps: { as: components?.Form },
      externalSlotProps: componentsProps?.form
    });
    const actionsSlotProps = useSlotProps({
      className: utilityClasses.actions,
      ownerState,
      elementType: Actions,
      additionalProps: { as: components?.Actions },
      externalSlotProps: componentsProps?.actions
    });
    return /* @__PURE__ */ jsxs(Root, { ...rootSlotProps, children: [
      logo && /* @__PURE__ */ jsx(Logo, { ...logoSlotProps, children: logo }),
      title && /* @__PURE__ */ jsx(Title, { ...titleSlotProps, children: title }),
      showAlert && /* @__PURE__ */ jsx(Alert, { ...alertSlotProps, children: alert }),
      message && /* @__PURE__ */ jsx(Message, { ...messageSlotProps, children: message }),
      /* @__PURE__ */ jsx(Form, { ...formSlotProps, children: form }),
      actions && /* @__PURE__ */ jsx(Actions, { ...actionsSlotProps, children: actions })
    ] });
  }
);
export {
  LoginFormContainer
};
//# sourceMappingURL=LoginFormContainer.js.map
